/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'input': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M326.656 188.416L0 753.664 32.768 1024l249.856-107.008L609.28 351.744 326.656 188.416zm27.29-46.95L435.61.05 718.49 163.38l-81.664 141.415zM409.6 921.6H1024V1024H409.6z"/>'
  }
})
